import { Component, Input } from '@angular/core';

@Component({
  selector: 'mpf-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
  @Input() message: string;
}



// WEBPACK FOOTER //
// /vercel/path0/src/app/components/loading/loading.component.ts